// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + {"43":"page-policy","181":"page-policy-detail","193":"page-policy-personal-data","374":"page-partners"}[chunkId] + "." + {"43":"b2f21aed","181":"34484b91","193":"1c5e5ba0","374":"df9f1a37"}[chunkId] + ".chunk.js";
};